import React, { useContext, useMemo } from 'react'

import Cookies from 'js-cookie'

import InternshipsTableHead from './InternshipsTableHead'
import { InternshipsManagerContext } from '../../../Context/InternshipsManager/InternshipsManagerProvider'
import InternshipsTableBody from './InternshipsTableBody'

const InternshipsTable = ({ loading }) => {
  const { getDataReady, onTableLeave } = useContext(InternshipsManagerContext)

  const height = useMemo(() => {
    return `calc(100vh - ${Cookies.get('switch_user_id') ? '242px' : '201px'})`
  }, [Cookies.get('switch_user_id')])

  return (
    <div className='internship-manager-table' style={{ height }}>
      <table className='internships-manager' onMouseLeave={onTableLeave}>
        <InternshipsTableHead />
        <InternshipsTableBody
          loading={loading || !getDataReady.schools || !getDataReady.institutions || !getDataReady.students}
        />
      </table>
    </div>
  )
}

export default InternshipsTable
